import { calculateCategoryStandings } from './category-standings.models';

export function resultAverageSpeed(distanceKm?: number | null, timeSeconds?: number | null, statusCode?: string | null, imported?: number | null): number | null {
  if (statusCode || !timeSeconds || !Number.isFinite(timeSeconds) || timeSeconds <= 0) return null;
  if (imported && Number.isFinite(imported) && imported > 0) return imported;
  return distanceKm && Number.isFinite(distanceKm) && distanceKm > 0 ? distanceKm * 3600 / timeSeconds : null;
}

interface DisplayRow { rank: string; categorie: string; temps: string; categoryRank?: number; averageSpeedKmph?: number | null; statusCode?: string; }
export function enrichResultTables<T extends {distance: string; results: DisplayRow[]}>(races: T[]): T[] {
  return races.map(race => {
    const seconds = race.results.map(row => {
      if (!/^\d{1,3}:\d{2}(:\d{2})?$/.test(row.temps)) return 0;
      return row.temps.split(':').reduce((total,part) => total * 60 + Number(part),0);
    });
    const distance = /^\s*(\d+(?:[.,]\d+)?)\s*(?:km)?\s*$/i.exec(race.distance);
    const standings = calculateCategoryStandings(race.results.map((row,index)=>({
      id:String(index),raceId:'race',category:row.categorie === '-' ? null : row.categorie,
      categoryRank:row.categoryRank,position:Number(row.rank),timeSeconds:row.statusCode ? 0 : seconds[index],
    })));
    return {...race,results:race.results.map((row,index)=>({...row,
      categoryRank:standings[String(index)]?.rank,
      averageSpeedKmph:resultAverageSpeed(distance ? Number(distance[1].replace(',','.')) : null,seconds[index],row.statusCode,row.averageSpeedKmph),
    }))};
  });
}
